import { useCurrentTill } from "~/api/tills/hooks/use-till-current";

type UseUserBalanceArgs = {
  unitAvailableInclVat?: number | null;
  balance?: number | null;
};

/**
 * Calculate the available balance for the user, the minimum between the limit available and the balance
 * @param unitAvailableInclVat - The available limit for the user
 * @param balance - The balance of the user
 * @returns The available balance
 */
export const useUserBalance = ({
  unitAvailableInclVat,
  balance
}: UseUserBalanceArgs): number | null => {
  const { data: till } = useCurrentTill();

  if (till?.type !== "collect") {
    return balance ?? null;
  }

  if (typeof unitAvailableInclVat !== "number") {
    return Math.max(balance ?? 0, 0);
  }

  if (typeof balance !== "number") {
    return Math.max(unitAvailableInclVat, 0);
  }

  if (unitAvailableInclVat < 0 || balance < 0) {
    return 0;
  }

  return Math.min(unitAvailableInclVat, balance);
};
